module.exports = __webpack_public_path__ + "img/发呆.346e38b3.gif";